import {RequestCookies} from 'next/dist/compiled/@edge-runtime/cookies';
import {ClientCookies} from './clientCookies';
import {getIsServer} from './getIsServer';

export const getCookies = async () => {
    if (!getIsServer()) {
        return ClientCookies;
    }
    return require('next/headers').cookies() as RequestCookies;
};
